<template>
  <div>
    <div class="litops orangeToYellow com_top">
      <!-- 设备名称 -->
      <span>{{ name }}</span>
      <!-- 设备编号 -->
      <span>{{ no }}</span>
    </div>

    <div class="body">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: '',
      no: '',
    }
  },

  mounted() {
    this.name = localStorage.getItem('dname')
    this.no = localStorage.getItem('no')
  },
}
</script>

<style>
html {
  background: #f9f9f9;
}
</style>
<style lang="scss" scoped>
.com_top {
  font-size: 14px;
  color: #ffffff;
  height: 60px;
  line-height: 60px;
  padding: 0 10px;

  > span {
    margin-right: 10px;
  }
}

.body {
  // position: absolute;
  top: 60px;
  right: 0;
  bottom: 0;
  left: 0;
  width: auto;
  min-height: 100%;
  background: #f9f9f9;
  padding: 0 15px;
  padding-bottom: 20px;
}
</style>
